export const APP_LINKS = {
  appStore: "https://apps.apple.com/in/app/ind-ril/id6785839574",
  googlePlay: "https://play.google.com/store/apps/details?id=app.emergent.indiareels1f783207d",
};
